import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-missing",
  "use": "icon-status-missing-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-status-missing\"><g clip-path=\"url(#icon-status-missing_clip0_8541_8662)\"><path d=\"m8 4.66 5.02 8.673H2.98zM8 2 .667 14.667h14.666zm.666 9.333H7.333v1.334h1.333zm0-4H7.333V10h1.333z\" /></g><defs><clipPath id=\"icon-status-missing_clip0_8541_8662\"><path d=\"M0 0H16V16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol